import React from 'react';
import {
  DateRangeDropdownV2 as DateRangeField,
  DocumentNumberRangeFieldV2 as DocumentNumberRangeField,
  FormField,
  SearchField
} from '@/components/custom/erp';
import { SearchFieldActions, SearchFieldState } from '../../hooks';
import { accountSearchColumns, QUERY_KEYS } from '@/constants';
import { AccountModel } from '@/types/schemas';
import { Label } from '@/components/ui/label';

interface BasicInfoTabProps {
  formState: {
    state: SearchFieldState;
    actions: SearchFieldActions;
  };
}

const BasicInfoTab = ({ formState: { state, actions } }: BasicInfoTabProps) => {
  return (
    <div className='p-4'>
      <div className='flex items-center gap-3'>
        <Label className='w-40'>Ngày c/từ (từ/đến)</Label>
        <DateRangeField
          label='Ngày c/từ (từ/đến)'
          fromDateName='ngay_ct1'
          toDateName='ngay_ct2'
          toFieldClassName='w-44'
          fromFieldClassName='w-44'
        />
      </div>

      {/* Số c/từ (từ/đến) */}
      <DocumentNumberRangeField
        label='Số c/từ (từ/đến)'
        fromName='so_ct1'
        toName='so_ct2'
        labelClassName='w-40 shrink-0 text-[13px]'
      />

      <div className='flex items-center'>
        <Label className='w-40'>Loại xuất</Label>
        <div className='w-[210px]'>
          <FormField
            name='ma_ngv'
            type='select'
            options={[
              { label: 'Tất cả', value: 'ALL' },
              { label: '1. Chi theo hóa đơn', value: '1' },
              { label: '2. Chi theo đối tượng', value: '2' },
              { label: '3. Chi khác', value: '3' },
              { label: '4. Rút tiền về nhập quỹ', value: '4' },
              { label: '6. Bán hàng chi tiền ngay', value: '6' }
            ]}
          />
        </div>
      </div>

      {/* Tài khoản nợ */}
      <div className='flex items-center'>
        <Label className='w-40'>Tài khoản có</Label>
        <SearchField<AccountModel>
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/`}
          searchColumns={accountSearchColumns}
          columnDisplay='code'
          displayRelatedField='name'
          dialogTitle='Danh mục tài khoản'
          value={state.taiKhoanCo?.code || ''}
          relatedFieldValue={state.taiKhoanCo?.name || ''}
          onRowSelection={actions.setTaiKhoanCo}
        />
      </div>

      {/* Diễn giải */}
      <div className='flex items-center'>
        <Label className='w-40'>Diễn giải</Label>
        <div className='flex-1'>
          <FormField name='dien_giai' />
        </div>
      </div>
    </div>
  );
};

export default BasicInfoTab;
